<template>
    <v-container pa-0>
        <v-card class="px-2 pt-2 pb-6 mt-3" flat tile>
            <div class="d-flex flex-row align-center mb-2">
                <back-button :fallback-route="fallbackBackButtonRoute" />
            </div>
            <error-list :errors="errors"></error-list>
            <v-card-title class="headline font-weight-bold pa-2">{{
                $vuetify.lang.t('$vuetify.profile.title')
            }}</v-card-title>
            <p class="body-1 px-2" v-if="currentUser">
                {{ currentUser.email }} <br />
                (<span class="body-2">{{
                    $vuetify.lang.t('$vuetify.profile.private_mail_hint')
                }}</span
                >)
            </p>
            <build-form
                :form-items="items"
                :actions="actions"
                :rules="rules"
                :form.sync="form"
                ref="form"
                class="px-2"
            />
        </v-card>
    </v-container>
</template>
<script>
// 3rd
import { mapActions, mapState } from 'vuex';
// models
import User from '../../models/User';
// components
import BuildForm from '../../components/Builders/BuildForm';
import BackButton from '../../components/BackButton';
import ErrorList from '../../components/ErrorList';
// utils
import { ROUTE_PROFILE } from '../../utils/constants';
import {
    birth_date,
    business_email,
    business_phone,
    city,
    country,
    first_name,
    last_name,
    private_phone,
    salutation,
    street,
    street_number,
    zip_code
} from '../../utils/formRules';
import {
    redirect,
    transformArrayToSelectValues,
    setPageTitle
} from '../../utils/helper';

export default {
    name: 'change-data',
    components: {
        BuildForm,
        BackButton,
        ErrorList
    },
    data() {
        return {
            prefilled: false,
            errors: {},
            form: {
                gender: '',
                last_name: '',
                first_name: '',
                business_email: null,
                business_phone: null,
                employment_type: '',
                private_address_street: '',
                private_address_number: '',
                private_address_zip: '',
                private_address_city: '',
                private_address_country: '',
                private_phone: '',
                birth_date: null
            },
            rules: {
                salutation,
                last_name,
                first_name,
                business_email,
                business_phone,
                street,
                street_number,
                zip_code,
                city,
                birth_date,
                country,
                private_phone
            }
        };
    },
    computed: {
        ...mapState(['genders', 'employmentTypes', 'countryCodes']),
        salutations() {
            return transformArrayToSelectValues(
                this.genders,
                '$vuetify.salutation.'
            );
        },
        employment_types() {
            return transformArrayToSelectValues(
                this.employmentTypes,
                '$vuetify.employment_type.'
            );
        },
        country_codes() {
            return transformArrayToSelectValues(this.countryCodes, '');
        },
        items() {
            return [
                {
                    is: 'subhead',
                    name: 'privateSection',
                    label: '$vuetify.profile.private_data',
                    classes: 'mx-2 mb-2'
                },
                {
                    is: 'select',
                    name: 'gender',
                    label: '$vuetify.form_items.salutation',
                    options: this.salutations,
                    rule: 'salutation'
                },
                {
                    is: 'text',
                    name: 'last_name'
                },
                {
                    is: 'text',
                    name: 'first_name'
                },

                {
                    is: 'text',
                    label: '$vuetify.form_items.street',
                    name: 'private_address_street',
                    rule: 'street',
                    width: 8
                },
                {
                    is: 'text',
                    label: '$vuetify.form_items.street_number',
                    name: 'private_address_number',
                    rule: 'street_number',
                    width: 4
                },
                {
                    is: 'text',
                    label: '$vuetify.form_items.zip_code',
                    name: 'private_address_zip',
                    rule: 'zip_code',
                    width: 5
                },
                {
                    is: 'text',
                    label: '$vuetify.form_items.city',
                    name: 'private_address_city',
                    rule: 'city',
                    width: 3
                },
                {
                    is: 'select',
                    label: '$vuetify.form_items.country',
                    name: 'private_address_country',
                    options: this.country_codes,
                    rule: 'country',
                    width: 4
                },
                {
                    is: 'date',
                    name: 'birth_date'
                },
                {
                    is: 'phone',
                    name: 'private_phone'
                },
                {
                    is: 'subhead',
                    name: 'businessSection',
                    label: '$vuetify.profile.business_data',
                    classes: 'mx-2 mb-2'
                },
                {
                    is: 'hint',
                    name: 'business_email',
                    hint: '$vuetify.form_item_hints.business_email'
                },
                {
                    is: 'select',
                    name: 'employment_type',
                    options: this.employment_types,
                    disabled: true
                },
                {
                    is: 'text',
                    name: 'business_email',
                    hint: '$vuetify.form_item_hints.business_email',
                    optionalBy: 'employment_type:freelancer'
                },
                {
                    is: 'phone',
                    name: 'business_phone',
                    optionalBy: 'employment_type:freelancer'
                }
            ];
        },
        actions() {
            return [
                {
                    is: 'button',
                    name: 'save',
                    color: 'primary',
                    clickMethod: this.submit
                }
            ];
        },
        fallbackBackButtonRoute() {
            return { name: ROUTE_PROFILE };
        },
        currentUser() {
            return User.getCurrent();
        }
    },
    methods: {
        ...mapActions(['setSnackbar']),
        prefillForm() {
            this.form.gender = this.currentUser.gender;
            this.form.last_name = this.currentUser.last_name;
            this.form.first_name = this.currentUser.first_name;
            this.form.business_email = this.currentUser.profile.business_email;
            this.form.business_phone = this.currentUser.profile.business_phone;
            this.form.private_address_street = this.currentUser.profile.private_address_street;
            this.form.private_address_number = this.currentUser.profile.private_address_number;
            this.form.private_address_zip = this.currentUser.profile.private_address_zip;
            this.form.private_address_city = this.currentUser.profile.private_address_city;
            this.form.private_address_country = this.currentUser.profile.private_address_country;
            this.form.employment_type = this.currentUser.profile.employment_type;
            this.form.private_phone = this.currentUser.profile.private_phone;
            this.form.birth_date = this.currentUser.profile.birth_date;
        },
        async submit() {
            try {
                await User.submitChangeData(this.form);
            } catch (e) {
                this.errors =
                    e.response && e.response.data && e.response.data.error
                        ? e.response.data.error
                        : {};
                return;
            }

            this.setSnackbar({
                positionX: 'left',
                type: 'success',
                text: 'updated_profile',
                time: 5000
            });

            redirect(ROUTE_PROFILE);
        }
    },
    watch: {
        currentUser() {
            if (!this.prefilled) {
                this.prefillForm();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.currentUser) {
                this.prefillForm();
            }
        });
    }
};
</script>
